import request from '@/utils/request'

// 待结算 列表
export function getFinanceOrder(params) {
  return request({
    url: '/finance/order',
    method: 'get',
    params: params
  })
}

// 查询供应商可以获取的金额
export function getFinanceOrderInfo() {
  return request({
    url: '/finance/order/info',
    method: 'get'
  })
}

// 获取供应商账户金额
export function accountAmount() {
  return request({
    url: '/mch/account/single',
    method: 'get'
  })
}


// 获取当前商户的财务总览
export function financeTotal(params) {
  return request({
    url: '/mch/account/overview',
    method: 'get',
    params
  })
}

// 待结算 列表（新）
export function getPendingSettlementList(params){
	return request({
		url: '/finance/order/getPendingSettlementList',
		method: 'get',
		params: params
	})
}



// WEBPACK FOOTER //
// ./src/api/finance.js